<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" >
      <b-col cols="10">
        <b-form inline>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="税号/名称"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
        </b-form>
      </b-col>
      <b-col cols="2">
          <b-button class="m-1 float-right" variant="primary" @click="addEntDialog">增加</b-button>
      </b-col>
    </b-row>
    <!-- 提示信息 -->
    <b-alert show dismissible class="mt-2">企业实名认证后，能够自动接收来自瑞宏网的进项发票</b-alert>
    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(enabled)="row">
          <b-form-checkbox v-model="row.item.enabled" disabled></b-form-checkbox>
        </template>

        <template v-slot:cell(verificated)="row">
          <b-form-checkbox v-model="row.item.verificated" disabled></b-form-checkbox>
        </template>

        <template v-slot:cell(actions)="row">
          <!-- <b-link @click="deleteEnt(row.item.id)" class="mr-2">删除</b-link> -->
          <b-link @click="setEntEnabled(row.item)" v-if="!row.item.enabled" class="mr-2">启用</b-link>
          <b-link @click="setEntEnabled(row.item)" v-if="row.item.enabled" class="mr-2">禁用</b-link>
          <b-link @click="openEntVerificatedDialog(row.item)" v-if="!row.item.verificated" class="mr-2">实名认证</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>   

    <b-modal
      id="addEntModal"
      title="添加企业"
      incline
      v-model="addEntDialogVisible"
      @ok="handleAdd"
    >
      <template slot="modal-ok">保存</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="addEntForm">
          <validation-provider
              :rules="validators.rules.entCode"
              :customMessages="validators.msgs.entCode"
              name="税号"
              v-slot="validationContext"
              >
            <b-form-group label="税号" :invalid-feedback="validationContext.errors[0]" label-for="input_ent_code">
              <b-form-input 
                id="input_ent_code"
                v-model="entDto.entCode" 
                :state="validateState(validationContext)"
                placeholder="请输入企业税号">
              </b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
              :rules="validators.rules.entName"
              :customMessages="validators.msgs.entName"
              name="名称"
              v-slot="validationContext"
            >
            <b-form-group label="名称" :invalid-feedback="validationContext.errors[0]">
              <b-form-input 
                v-model="entDto.entName" 
                :state="validateState(validationContext)"
                placeholder="请输入企业名称">
              </b-form-input>
            </b-form-group>
          </validation-provider>

        </validation-observer>
      </form>
    </b-modal>     

    <!-- 实名认证对话框 -->
    <b-modal
      id="setEntVerifcatedModal"
      title="实名认证"
      incline
      v-model="setEntVerificateDialogVisible"
      @ok="handleSetVerificate"
    >
      <template slot="modal-ok">实名认证</template>
      <template slot="modal-cancel">取消</template>
      <b-alert v-model="showAlert" variant="danger" id="msg">
        <p>{{ msg }}</p>
      </b-alert>
      <b-alert show variant="success">
        <p>通过实名认证后能够自动接收来自瑞宏网电子发票服务平台的电子发票信息</p>
        <p>第1步：登入https://inv-veri.chinatax.gov.cn/xgxz.html，安装“税务证书应用客户端”，安装对应“税盘的数字证书驱动”。如果电脑能够登陆总局”增值税发票综合服务平台“，表明驱动已经安装，直接进入第2步。</p>
        <p>第2步：在该电脑打开票管家，插入税盘，输入数字证书密码</p>
        <p>第3步：点击确认按钮完成实名认证</p>
      </b-alert>

      <form>

            <b-form-group label="数字证书密码" label-cols="3">
              <b-form-input 
                v-model="verificateDto.caPin" 
                placeholder="请输入税盘的数字证书密码">
              </b-form-input>
            </b-form-group>
      </form>
    </b-modal>

  </div>
</template>

<script>
import * as entFacade from "../../../api/ent-facade.js";
import dayjs from "dayjs";
export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      fields: [
        {
          key: "entCode",
          label: "税号"
        },
        {
          key: "entName",
          label: "名称"
        },
        {
          key: "enabled",
          label: "状态"
        },
        {
          key: "verificated",
          label: "实名认证"
        },
        {
          key: "expirationTime",
          label: "服务到期时间"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],
      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: this.orgId,
          keywords: "",
        },
        sortOrder: { entName: "descending" }
      },
      pageLoading: false,
      tableLoading: false, // 表格Loading状态
      showAlert: false,

      entDto: {
        orgId: this.orgId,
        entCode: "",
        entName: ""
      },

      verificateDto:{
        entId: "",
        entCode: "",
        caPin: ""
      },

      addEntDialogVisible: false,
      setEntVerificateDialogVisible: false,
      msg: "",

      // 错误提示
      validators: {
        rules: {
          entCode: {
            required: true,
            min: 18,
            max: 20
          },
          entName: {
            required: true,
            max: 100
          }
        },
        msgs: {
          entCode: {
            required: "企业税号不能为空",
            min: "长度在18到20个字符",
            max: "长度在18到20个字符"
          },
          entName: {
            required: "企业名称不能为空",
            max: "长度不能超过50个字符"
          }
        }
      },
    }
  },

  created() {},
  mounted() {
    // 异步加载列表数据
    this.handleQuery();

  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      entFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    handleQuery(){
      this.list()
    },
    deleteEnt(id){
      this.$bvModal
        .msgBoxConfirm("确认要删除该企业吗？", {
          title: "确认",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "删除",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if(value){
            this.handleDelete(id)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleDelete(id){
      console.log(id)
      entFacade
        .deleteEnt(id) // 异步调用后台接口
        .then(() => {
          this.$message({
            message: "删除企业成功",
            type: "success"
          });
          this.list()
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });

    },
    handleAdd(e){
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.addEntForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.entDto.orgId = this.orgId
        console.log(this.orgId)
        entFacade
          .addEnt(this.entDto)
          .then(() => {
            this.pageLoading = false;
            this.addEntDialogVisible = false
            this.$message({
              message: "添加企业成功",
              type: "success"
            });
            this.list();
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
          this.entDto={orgId: this.orgId, entCode:"", entName:""}; 

          this.$nextTick(() => {
            this.$refs.addEntForm.reset();
          });

     })
        
   },

    addEntDialog() {
      this.addEntDialogVisible = true
    },

    setEntEnabled(rowitem){
      let title = rowitem.enabled ? "禁用" : "启用"
      var msg = "";
      if(!rowitem.enabled && dayjs(rowitem.expirationTime) < dayjs()){
        msg = "该企业的服务费已到期，启用会产生扣费, "
      }
      this.$bvModal
        .msgBoxConfirm(msg + "确认要"+title+"该企业吗？", {
          title: "确认",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: title,
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if(value){
            this.handleEntEnabled(rowitem.id, !rowitem.enabled)
            console.log(!rowitem.enabled)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleEntEnabled(id, enabled){
      console.log(id + "-" + enabled)
      if(enabled){
        console.log(enabled)
        entFacade
          .enableEnt(id) // 异步调用后台接口
          .then(() => {
            this.$message({
              message: "企业启用成功",
              type: "success"
            });
            this.list()
          })
          .catch(err => {
            console.log("err", err);
            this.tableLoading = false;
          });

      }else{
        entFacade
          .disableEnt(id) // 异步调用后台接口
          .then(() => {
            this.$message({
              message: "企业禁用成功",
              type: "success"
            });
            this.list()
          })
          .catch(err => {
            console.log("err", err);
            this.tableLoading = false;
          });

      }
    },

    // 实名认证
    openEntVerificatedDialog(rowitem){
      this.verificateDto.entId = rowitem.id;
      this.verificateDto.entCode = rowitem.entCode;
      this.verificateDto.caPin = "";

      this.showAlert = false;
      this.msg = "";

      this.setEntVerificateDialogVisible = true;


    },

    handleSetVerificate(e){
      e.preventDefault();

      // this.test();
      this.entVerificate();
    },

    // 进行实名认证
    entVerificate(){
      // 首先获取版本号信息
      if(this.verificateDto.caPin == ""){
        this.showAlert = true;
        this.msg = "请输入数字证书密码";
        return;
      }
      this.$http.post('https://127.0.0.1:28000/api/getVersion', {
        crosFlag: 0
      },{emulateJSON: true}).then(function(res){
        console.log(res)
        if(res.body.code=="0"){
          // 断开税盘连接
          this.verifyPinApi1(this.verificateDto.caPin)
        }
      },
      (error) =>{
        console.log("连接失败" + error);
        this.showAlert = true;
        this.msg = "税盘连接失败，请检查驱动是否安装或者本机是否能够登陆'增值税发票综合服务平台'"
      });
      
    },

    verifyPinApi1(pwd){
      pwd = encodeURIComponent(pwd);
      this.$http.post('https://127.0.0.1:28000/api/verifyPin', {
        password: pwd,
        dwProvType: 2050,
        strContainer: "//SM2/SM2CONTAINER0002"
    },{emulateJSON: true}).then(function(res){
        console.log(res);
        if(res.body.code=="167"){
          // 
          this.verifyPinApi2(pwd)
        }
        if(res.body.code=="0"){
          this.readCertInfo(false)
        }else{
            this.showAlert = true;
            this.msg = res.body.msg;
        }
      },
      (error) =>{
        console.log("连接失败");
        console.log(error);
      });

    },

    verifyPinApi2(pwd){
      // pwd = encodeURIComponent(pwd);
      this.$http.post('https://127.0.0.1:28000/api/verifyPin', {
        password: pwd,
        dwProvType: 1,
      },{emulateJSON: true}).then(function(res){
          console.log(res);

          if(res.body.code=="0"){
            // 
            this.readCertInfo(true);
          }else{
            this.showAlert = true;
            this.msg = res.body.msg;
          }
        },
        (error) =>{
          console.log("连接失败");
          console.log(error);
        });

    },

    readCertInfo(mode){
      var data = mode == true ? {
        certInfoNo: 71,
        dwProvType: 1
      } : {
        certInfoNo: 71,
        dwProvType: 2050,
        strContainer: "//SM2/SM2CONTAINER0002"
      }
      this.$http.post('https://127.0.0.1:28000/api/readCertInfo',
        data
        ,{emulateJSON: true}).then(function(res){
          console.log(res);
          if(res.body.code=="0"){
            // 
            if(res.body.certInfo == this.verificateDto.entCode){
              console.log(res.body.certInfo);
              this.verificateEnt(this.verificateDto.entId);
            }else{
              // 实名认证未通过
              console.log("实名认证未通过")
              this.showAlert = true;
              this.msg = "实名认证未通过,请检查是否插入了正确的税盘";
            }
          }
        },
        (error) =>{
          console.log("连接失败");
          console.log(error);
        });

    },

    verificateEnt(id){
      entFacade
        .verificateEnt(id) // 异步调用后台接口
        .then(() => {
          this.setEntVerificateDialogVisible = false;
          this.$message({
            message: "企业实名认证成功",
            type: "success"
          });
          this.list()
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

  },


};
</script>

<style >
</style>
